import axiosInstance from '../lib/axios-instance';

export type TState = {
  name: string;
  abbreviation: string;
};

export type TGetStatesRes = {
  states: TState[];
};

export const getStates = async (country?: string): Promise<TGetStatesRes> => {
  try {
    const params = country ? { country } : {};
    const res = await axiosInstance.get('/states-payee', { params });
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error('Failed to get states');
  }
};
